// extracted by mini-css-extract-plugin
export default {"container":"FatigueTypeformLink_container__GlGD9"};